export default {
    category: 'Category',
    status: 'Status',
    project: {
        headers: {
            'settingsTitle':      'Projects Portfolio REC settings',
            'massSettingsTitle':  'Projects Portfolio MASS settings',
            'title':              'Projects Portfolio',
            'posname':            'Position Title',
            'numeqpos':           'Number',
            'duration':           'Duration (days)',
            'responsible':        'Responsible',
            'participants':       'Project Participants',
            'workinhrnet':        'Work Over HR-network',
            'approval':           'Approval',
            'company':            'Company',
            'icustomer':          'Internal Client',
            'finalist':           'Finalist, Probationer, Employed',
            'reqdate':            'Request Date',
            'conditions':         'Conditions',
            'prjtype':            'Project Type',
            'selmethod':          'Recruitment Type',
            'status':             'Status',
            'closebefore':        'Close before',
            'approvalppls':       'Approvers',
            'respforcompany':     'Resp. for Work with Company',
            'feetype':            'Fee (type of conditions)',
            'feepercent':         'Fee (percentage)',
            'amount':             'Position Fee (amount)',
            'foreignlngs':        'Foreign Languages',
            'sex':                'Sex',
            'age':                'Age',
            'workplace':          'Workplace',
            'schedule':           'Work Schedule',
            'worktype':           'Employment Type',
            'compdepart':         'Department in Company’s Structure',
            'posdepart':          'Department where the job is open',
            'probation':          'Probation period',
            'classifier':         'Classifier',
            'town':               'City',
            'amountmin':          'Salary min.',
            'amountmax':          'Salary max.',
            'feecurrency':        'Fee Currency',
            'bonuses':            'Compensations and benefits',
            'experience':         'Experience requirements',
            'responsibilities':   'Responsibilities',
            'workresps':          'Responsibilities',
            'education':          'Education',
            'personalqual':       'Personal qualities',
            'comments':           'Note',
            'subgroup':           'Responsible’s Sub-group/Group',
            'emplofra':           'Employees of RA',
            'feeperpos':          'Position fee',
            'transprice':         'Tranfer price',
            'cforesps':           'CFO of responsible',
            'cfotoplevel':        'CFO of top level',
            'salary':             'Salary',
            'requirements':       'Requirements',
            'candidates':         'Candidates',
            'workcommit':         'Work commit',
            'result':             'Finalist, Probationer, Employed',
            'prjstart':           'Project start',
            'negwithclientHR':    'Negotiations with RA',
            'negwithclientKA':    'Negotiations with client',
            'clientcontactpers':  'Client contacts',
            'feecomments':        'Fee comment',
            'kad_bdm':            'KAM/BDM',
            'coordinator':        'Coordinator',
            'department':         'Department',
            'warranty':           'Warranty period',
            'actmarketing':       'Active marketing',
            'execdate':           'Execution date',
            'lastchgdate':        'Date of last change',
            'ancorinfo':          'Ancor info',
            'notes':              'Notes',
            'category':           'Category',
            'attdocuments':       'Document attachments',
            'budget':             'Presence in the Budget',
            'reason':             'Reason of Opening',
            'message':            'Message',
            'ParticipantsWithRole': 'Co-executors',
            'scenname':           'Scenario',
            'inworkdate':         'In work since',
        },
        position: 'Position',
        quantityPosition: 'Position\'s total',
        restPosition: 'Position\'s rest',
        company: 'Company',
        city: 'City',
        department: 'Department',
        budget: 'Presence in the Budget',
        reason: 'Reason of Opening',
        status_project: 'Project status',
        inworksinse: 'In Work since',
        duration: 'Duration',
        deadline: 'Close before',
        participants: 'Project participants',
        requirements_for_candidate: 'Requirements for a candidate',
        experience: 'Experience Requirements',
        education: 'Education',
        languages: 'Foreign languages',
        sex: 'Sex',
        age: 'Age',
        typeofexperience: 'Terms of Empl.',
        personal_qualities: 'Personal Qualities',
        responsibilities: 'Responsibilities',
        workConditions: 'Working conditions',
        salary: 'Salary',
        bonuses: 'Bonuses',
        probation: 'Probation',
        days: 'days',
        workplace: 'Employer',
        schedule: 'Work Schedule',
        workType: 'Employment Type',
        work: {
            approval: 'Approval',
        },
        project_information: 'Project card',
        additional_information: 'Additional information',
        conditions: 'Position Fee',
        to_worksheet: 'Move to worksheet',
        type: 'Project type',
        scenario: 'Scenario',
    },
};
